module.exports = __webpack_public_path__ + "img/831.99688369.png";